import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab"]

  connect() {
    // Show first tab content by default
    this.showTabContent("resumen")
  }

  switchTab(event) {
    const clickedTab = event.currentTarget
    const tabId = clickedTab.dataset.tabId

    // Update tab styles
    this.tabTargets.forEach(tab => {
      tab.classList.remove("lease-detail-tabs__tab--active")
    })
    clickedTab.classList.add("lease-detail-tabs__tab--active")

    // Show corresponding content
    this.showTabContent(tabId)
  }

  showTabContent(tabId) {
    // Hide all tab contents
    const allContents = document.querySelectorAll('.lease-tab-content')
    allContents.forEach(content => {
      content.style.display = 'none'
    })

    // Show selected tab content
    const selectedContent = document.getElementById(`${tabId}-content`)
    if (selectedContent) {
      selectedContent.style.display = 'block'
    }
  }
}
